import requset from "./config";
import { UID } from "./constants";

// 获取基础数据
export const GET_DATA = () => {
  let params = new FormData();
  params.append("act", "Event_GetForm");
  params.append(
    "param",
    JSON.stringify({
      uid: UID,
    })
  );

  return requset({
    method: "post",
    data: params,
  });
}


// 获取微信用户信息:
export const GET_wx_userinfo = (code,companyID,wXIdentificationType)=>{
  let params = new FormData();
  params.append('act','GetWxFanOpenId');
  params.append("param",JSON.stringify({
    uid:UID,
    companID:companyID,
    code:code,
    WxIdentificationType:wXIdentificationType,
    type:1
  }));

  return requset({
    method:'post',
    data:params
  })
}


// 提交表单
export const submitInfo = (values,eventUID,uid,companyID,openId) => {
  const { fId0, fId1, fId2, fId3 } = values;
  let params = new FormData();
  params.append("act", "Event_CreateEventsFormRecord");
  params.append(
    "param",
    JSON.stringify({
      Field0:fId0,
      Field1:fId1,
      Field2:fId2,
      Field3:fId3,
      EventUID:eventUID,
      EventFormUID:uid,
      CompanyID:companyID,
      OpenID:openId
    })
  );
 
  return requset({
    method:'post',
    data:params
  })
};

// 是否关注公众号
export const isLike = (openid,uid,companyID)=>{
  let parmes = new FormData();
  parmes.append("act","JudgeFollowPublicAccount");
  parmes.append("param",JSON.stringify({
    openId:openid,
    uid:uid,
    type:1,
    companID:companyID,
  }))


  return requset({
    method:'post',
    data:parmes
  })
}


export const getShare = (companyID,URL)=>{

  let parmes = new FormData();
  parmes.append("act","GetShare");
  parmes.append("param",JSON.stringify({
    companyID:companyID,
    url:URL
  }))

  return requset({
    method:'post',
    url:'http://digital.a2china.cn/Html/WxPageService/Handlers/Handler.ashx',
    data:parmes
  })
}